import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'joblist',
    component: () => import(/* webpackChunkName: "about" */ '@/views/job/JobList.vue')
  },
  {
    path: '/JobDetail',
    name: 'JobDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/job/JobDetail.vue')
  },
  {
    path: '/publishJob',
    name: 'publishJob',
    component: () => import(/* webpackChunkName: "about" */ '@/views/job/publishJob.vue')
  },
  {
    path: '/PersonDetail',
    name: 'PersonDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/Person/PersonDetail.vue')
  },
  {
    path: '/myReleaseDetail',
    name: 'myReleaseDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/myRelease/myReleaseDetail.vue')
  },
  {
    path: '/myAcceptDetail',
    name: 'myAcceptDetail',
    component: () => import(/* webpackChunkName: "about" */ '@/views/myAccept/myAcceptDetail.vue')
  },
  {
    path: '/managerJob',
    name: 'managerJobList',
    component: () => import(/* webpackChunkName: "about" */ '@/views/managerJob/managerJobList.vue')
  },
  {
    path: '/aaa',
    name: 'aaa',
    component: () => import(/* webpackChunkName: "about" */ '@/views/aaa.vue')
  },
]

const router = new VueRouter({
  // mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
